import { firebaseDb } from '../firebase/'

export const loadUsers = () => (
  dispatch => {
    firebaseDb.collection('users').onSnapshot(snapshot => (
      dispatch({
        type: 'LOAD_USERS',
        snapshot
      })
    ), err => {
      console.log('Encountered error', err);
    })
  }
)



// WEBPACK FOOTER //
// ./src/actions/users.js